export const TEST = "TEST"
export const VACC = "VACC"
export const RCVD = "RCVD"

export const covidDocumentTypeOptions = [
  { code: TEST, name: "Schnelltest (quick test)" },
  { code: VACC, name: "Impfung (vaccine)" },
  { code: RCVD, name: "Genessen (recovered)" },
]
